import { useQuery } from '@do/seashell/graphql';
import { useParams, useNavigate } from '@do/seashell/navigation';
import { Background, Box, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import background from '../assets/backgrounds/background.png';
import copy from '../copy';
import { GetPasswordResetInfo } from '../generated-types/GetPasswordResetInfo';
import useDocumentTitle from '../hooks/use-document-title';
import { GET_PASSWORD_RESET_FORM_DATA } from '../queries/queries';
import Button from './Button';
import { Loading, Wrap } from './Common';
import FormWrap from './FormWrap';
import Header from './Header';
import PasswordResetForm from './PasswordResetForm';
import Text from './Text';
import Title from './Title';

function PasswordReset(): ReactElement {
  const { token = '' } = useParams();

  const { loading: isLoading, error } = useQuery<GetPasswordResetInfo>(
    GET_PASSWORD_RESET_FORM_DATA,
    {
      variables: {
        token
      }
    }
  );

  const navigate = useNavigate();

  useDocumentTitle(copy.form.password_reset_title);

  if (isLoading) {
    return <Loading isLogin={true} />;
  }

  return (
    <>
      <Header isLogin={true} />
      <Background url={background} />
      <Wrap>
        <FormWrap>
          <Box display="block" px={style.vars.whitespace.medium}>
            <Title
              title={
                !error
                  ? copy.form.password_reset.title
                  : copy.form.password_reset.error_title
              }
            />
            <Text>
              {!error
                ? copy.form.password_reset.details
                : copy.form.password_reset.error_details}
            </Text>
            {!error ? (
              <PasswordResetForm token={token} />
            ) : (
              <Button
                onClick={() => navigate('/forgot_password/new')}
                fullWidth
              >
                {copy.form.password_reset.button_text}
              </Button>
            )}
          </Box>
        </FormWrap>
      </Wrap>
    </>
  );
}

export default PasswordReset;
